// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2M1TY","name":"ConsentHeader_name__2xu3K","birthday":"ConsentHeader_birthday__3gyqp","skeleton":"ConsentHeader_skeleton__2NsVn"};